import { React, useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SongListCriteriaList from './SongListCriteriaList';

export default function SongListSongCriteria(props) {
    const [availableItems, setAvailableItems ] = 
        useState([]);
    const [includeItems, setIncludeItems ] = 
        useState([]);
    const [excludeItems, setExcludeItems ] =
        useState([]);

    return(
        <Row style={{ 'height': '44vh', 'max-height':'44vh'}}>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Available Songs</Card.Title>
                    <SongListCriteriaList items={availableItems}
                                        criteriaType='song'
                                        itemGroup='available' />
                    <Card.Footer className='text-muted'>Drag and drop songs to add or remove from the list</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Included Songs</Card.Title>
                    <SongListCriteriaList items={includeItems}
                                        criteriaType='song'
                                        itemGroup='include' />
                    <Card.Footer className='text-muted'>These songs will be included in the list</Card.Footer>
                </Card>
            </Col>
            <Col style={{ 'height': '100%', 'max-height':'100%'}}>
                <Card style={{ 'height': '100%', 'max-height':'100%'}}>
                    <Card.Title className='mx-auto'>Excluded Songs</Card.Title>
                    <SongListCriteriaList items={excludeItems}
                                        criteriaType='song'
                                        itemGroup='exclude' />
                    <Card.Footer className='text-muted'>These songs will be excluded from the list</Card.Footer>
                </Card>
            </Col>
        </Row>
    )
}